<template>
  <div class="w-full rounded px-2 pt-2 pb-8 mb-6">
    <el-row :gutter="20">
      <el-col :span="24" class="mb-6">
        <el-button icon="el-icon-back" size="small"
                   @click="$router.push('/ecommerce/supply/suppliers')">Back to list</el-button>
      </el-col>
    </el-row>
    <el-form :model="form" :label-position="labelPosition" :rules="rules" ref="form">
      <SuppliersForm :form="form" />
      <el-form-item :gutter="20" class="px-5">
        <el-button type="primary" @click="submit('form')" :loading="adding">Save</el-button>
        <el-button @click="cancelCreate" type="info">Cancel</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

import SuppliersForm from './_includes/SuppliersForm.vue';

export default {
  name: 'NewSuppliers',
  data() {
    return {
      adding: false,
      labelPosition: 'top',
      rules: this.$store.state.InventoryModule.Suppliers.validate_form,
    };
  },
  components: {
    SuppliersForm,
  },
  computed: {
    form() {
      return this.$store.state.InventoryModule.Suppliers.new_supplier;
    },
    countries() {
      return this.$store.state.SettingsModule.Location.countries.data;
    },
    states() {
      return this.$store.state.SettingsModule.Location.states;
    },
    cities() {
      return this.$store.state.SettingsModule.Location.cities;
    },
    groups() {
      return this.$store.state.InventoryModule.SuppliersGroup.suppliers_groups;
    },
  },
  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    const page = 1; const limit = 1000;
    try {
      await this.$store.dispatch('SettingsModule/Location/fetchMerchantCountries', { page, limit });
      await this.$store.dispatch('InventoryModule/SuppliersGroup/fetchAllSuppliersGroups');
    } catch (e) {
      this.$notify.error({
        title: 'Error',
        message: 'Something went wrong please try again.',
      });
    }
  },
  methods: {
    async cancelCreate() {
      this.$router.back();
    },
    submit(form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          try {
            this.adding = true;
            await this.$store.dispatch('InventoryModule/Suppliers/newSupplier', { supplier: this.form });
            this.$notify.success({
              title: 'Success',
              message: 'Supplier successfully added',
            });
            await this.$router.push(`/ecommerce/supply/suppliers/${
              this.$store.state.InventoryModule.Suppliers.supplier.id
            }/details`);
          } catch (e) {
            this.adding = false;
            this.$notify.error({
              title: 'Error',
              message: 'Something went wrong',
            });
          }
          this.adding = false;
        } else {
          return false;
        }
      });
    },
    async onGetStates(countryId) {
      await this.$store.dispatch('SettingsModule/Location/fetchMerchantStates', { countryId });
    },
    async onGetCities(stateId) {
      await this.$store.dispatch('SettingsModule/Location/fetchMerchantCities', { stateId });
    },
  },
};
</script>

<style scoped>

</style>
